import { render, staticRenderFns } from "./BaseFrontOfficeIcon.vue?vue&type=template&id=ced0d8fe&scoped=true"
import script from "./BaseFrontOfficeIcon.vue?vue&type=script&lang=js"
export * from "./BaseFrontOfficeIcon.vue?vue&type=script&lang=js"
import style0 from "./BaseFrontOfficeIcon.vue?vue&type=style&index=0&id=ced0d8fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced0d8fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
